import { ConfigurationType } from './configurator-options';

export abstract class CurrentConfiguratorService {
    conf: ConfigurationType;

    abstract changeConfigurator(conf: ConfigurationType);

    abstract setConfigurator(config: ConfigurationType);
}
